import React, { useEffect } from 'react';
import { Route, RouteComponentProps, withRouter } from 'react-router-dom';
import { useAuth0 } from '../react-auth0-spa';

interface Props extends RouteComponentProps {
  path: string | string[];
  component: React.ComponentType<any>;
  exact: boolean;
  render?: (props: any) => JSX.Element;
}

const PrivateRoute: React.FC<Props> = ({ component: Component, path, ...rest }) => {
  const { loading, isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (loading || isAuthenticated) {
      return;
    }
    const fn = async () => {
      if (loginWithRedirect) {
        await loginWithRedirect({
          appState: { targetUrl: window.location.pathname }
        });
      }
    };
    fn();
  }, [loading, isAuthenticated, loginWithRedirect, path]);

  const render = (props: any) =>
    isAuthenticated === true ? <Component {...props} /> : null;

  return <Route path={path} render={render} {...rest} />;
};

export default withRouter(PrivateRoute);
